import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'

import auth from './Auth';
import construction from './Construction';
import user from './User';
import session from './Session';
import checkin from './Checkin';
import company from './Company';
import payment from './Payment';
import salary from './Salary';

const rootReducer = combineReducers({
  auth,
  construction,
  user,
  session,
  checkin,
  company,
  payment,
  salary,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js